import React from 'react';

import { LabelInput } from '@/components/ui/inputs';
import { SidePanelFormLayout } from '@/components/layout';
import { CollapsibleSection } from '@/components/ui/panels';
import { Text } from '@/components/ui/text/Text';
import { colors } from '@/assets/styles/colors';
import { useTranslation } from '@/i18n';
import type { AssignedEmployee } from '@/api/domains/securityGrouping';


interface AssignedEmployeeDetailPanelProps {
  employee: AssignedEmployee;
}

export const AssignedEmployeeDetailPanel: React.FC<AssignedEmployeeDetailPanelProps> = ({
  employee,
}) => {
  const { t: translate } = useTranslation();

  return (
    <SidePanelFormLayout>
      <SidePanelFormLayout.Fields>
        <LabelInput
          label={translate('securityGrouping:assignedEmployees.detail.rut')}
          value={employee.rut}
          disabled
          fullWidth
          data-testid="assigned-employee-detail-rut"
        />
        <LabelInput
          label={translate('securityGrouping:assignedEmployees.detail.name')}
          value={employee.name}
          disabled
          fullWidth
          data-testid="assigned-employee-detail-name"
        />
        <LabelInput
          label={translate('securityGrouping:assignedEmployees.detail.status')}
          value={employee.status}
          disabled
          fullWidth
          data-testid="assigned-employee-detail-status"
        />
      </SidePanelFormLayout.Fields>

      <CollapsibleSection
        title={translate('securityGrouping:assignedEmployees.detail.adminGroups')}
        count={employee.adminGroupsCount}
        defaultExpanded
      >
        <ul className="flex flex-col gap-2 pb-2">
          {employee.adminGroupNames.map((groupName) => (
            <li key={groupName}>
              <Text variant="body-regular" color={colors.grays.neutral33}>
                {groupName}
              </Text>
            </li>
          ))}
        </ul>
      </CollapsibleSection>

      <CollapsibleSection
        title={translate('securityGrouping:assignedEmployees.detail.memberGroups')}
        count={employee.memberGroupsCount}
        defaultExpanded
      >
        <ul className="flex flex-col gap-2 pb-2">
          {employee.memberGroupNames.map((groupName) => (
            <li key={groupName}>
              <Text variant="body-regular" color={colors.grays.neutral33}>
                {groupName}
              </Text>
            </li>
          ))}
        </ul>
      </CollapsibleSection>
    </SidePanelFormLayout>
  );
};

export default AssignedEmployeeDetailPanel;
